function initPrintessIntegration(settings) {
    settings = settings ? settings : {};
    let addToBasketCallback = null;
    let goBackCallback = null;
    let formFieldChangedCallback = null;

    const removeLeadingAndTrailingSlash = (txt) => {
        txt =(txt || "").trim();
      
        if(txt.length > 0) {
          while(txt.length > 0 && txt[0] === '/') {
            txt = txt.substr(1);
          }
      
          while(txt.length > 0 && txt[txt.length - 1] === '/') {
            txt = txt.substr(0, txt.length - 1);
          }
        }
      
        return txt;
    };

    const showEditor = (templateNameOrSaveToken, formFieldValues, callbacks, meta) => {
        let iframe = document.getElementById("printess-iframe");
        let isNewInstance = false;

        addToBasketCallback = (callbacks && typeof callbacks.addToBasket === "function") ? callbacks.addToBasket : null;
        goBackCallback = (callbacks && typeof callbacks.goBack === "function") ? callbacks.goBack : null;
        formFieldChangedCallback = (callbacks && typeof callbacks.formFieldChanged === "function") ? callbacks.formFieldChanged : null;

        if(!iframe) {
            isNewInstance = true;
            
            iframe = document.createElement('iframe');
            let version = removeLeadingAndTrailingSlash(settings.version);

            version = version ? version + "/" : "";
          
            iframe.setAttribute("src", '//editor.printess.com/' + version + 'printess-editor/embed.html');
            iframe.setAttribute("id", "printess-iframe");
            iframe.classList.add("printess-iframe");

            document.body.appendChild(iframe);
        }

        iframe.style.display = "block";

        if(isNewInstance) {
            iframe.onload = () => {
                /* **************************** */
                /* listen to printess callbacks */
                /* **************************** */
                window.addEventListener("message", () => {
                    switch (event.data.cmd) {
                        case "back":
                            hideEditor();

                            if(typeof goBackCallback === "function") {
                                goBackCallback(meta);
                            }
                            break;
                        case "basket":
                            if(typeof addToBasketCallback === "function") {
                                addToBasketCallback(event.data.token, event.data.thumbnailUrl, meta);
                            }

                            hideEditor();

                            break;
                        case "formFieldChanged":
                            if(typeof formFieldChangedCallback === "function") {
                                formFieldChangedCallback(event.data.name, event.data.value, meta);
                            }

                            break;
                    }
                });

                iframe.contentWindow.postMessage(
                    {
                      cmd: 'attach',
                      properties: {
                        /* Paste your Printess token here */
                        token: settings.shopToken || '',
                        templateName: templateNameOrSaveToken,
                        showBuyerSide: true,
                        domain: "api.printess.com",
                        formFields: formFieldValues,
                        mergeTemplates: meta.mergeTemplates ? (Array.isArray(meta.mergeTemplates) ? meta.mergeTemplates : [meta.mergeTemplates]) : null,
                        languageKey: "auto"
                      }
                    },
                    '*'
                );
            }

            /* *************************** */
            /*   Forward Visual Viewport   */
            /* *************************** */
            if (window.visualViewport) {
                window.visualViewport.addEventListener("scroll", () => {
                    // unfortunately an iframe on iOS is not able to receive the correct visual-viewport, so we forward it. 
                    iframe.contentWindow.postMessage({ cmd: "viewportScroll", height: window.visualViewport.height, offsetTop: window.visualViewport.offsetTop },"*");
                })
            }
        } else {
            /* *************************** */
            /*    load Printess editor     */
            /* *************************** */
            let undef;
            iframe.contentWindow.postMessage({
                cmd: "loadTemplateAndFormFields",
                domain: "api.printess.com",
                parameters: [templateNameOrSaveToken, undef, formFieldValues, undef]
            }, "*");
        }
    };

    const hideEditor = () => {
        const iframe = document.getElementById("printess-iframe");

        if(iframe) {
            iframe.style.display = "none";
        }
    }

    if(!window.printess) {
        window.printess = {};
    }

    if(!window.printess.editor) {
        window.printess.editor = {
            show: (templateNameOrSaveToken, formFieldValues, callbacks, meta) => {
                showEditor(templateNameOrSaveToken, formFieldValues, callbacks, meta);
            },
            hide: () => {
                hideEditor();
            }
        };
    }

    return window.printess.editor;
}